import { render, staticRenderFns } from "./UITextField.vue?vue&type=template&id=457c3106"
import script from "./UITextField.vue?vue&type=script&lang=js"
export * from "./UITextField.vue?vue&type=script&lang=js"
import style0 from "./UITextField.vue?vue&type=style&index=0&id=457c3106&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports